import React from 'react';
import PropTypes from 'prop-types';
import { DEMO_TYPES } from '../../../../constants/reading/DemoModeConstants';
import './DemoModeHeader.scss';

const DemoModeHeader = ({
    demoHeaderBody,
    demoType,
    demoModeBar,
    demoModeToolTips,
    isDemoModeOn,
}) => {
    const inTour = demoType === DEMO_TYPES.GUIDED_TOUR ? 'in-tour' : '';

    return (
        isDemoModeOn && (
            <div
                className={`no-print flex-column ${inTour} layout-context-compact`}
                id="demo-mode-header"
            >
                {demoModeBar}
                {demoHeaderBody}
                {demoModeToolTips}
            </div>
        )
    );
};

DemoModeHeader.defaultProps = {
    demoType: '',
    demoModeBar: <></>,
    demoHeaderBody: <></>,
    demoModeToolTips: <></>,
    isDemoModeOn: false,
};

DemoModeHeader.propTypes = {
    demoType: PropTypes.string,
    demoHeaderBody: PropTypes.element,
    demoModeBar: PropTypes.element,
    demoModeToolTips: PropTypes.element,
    isDemoModeOn: PropTypes.bool,
};

export default DemoModeHeader;
